import { session_wxbean } from "@tencent/midas-util"

export class WechatBeanAccount {
  init(opt) {
    return new Promise((resolve, reject) => {
      if (opt.openid && opt.openkey) {
        let loginState = new session_wxbean({
          appid: opt.wx_appid,
          openid: opt.openid,
          accessToken: opt.openkey
        })
        resolve({ loginState: loginState })
      } else {
        reject("无登录态")
      }
    })
  }
}
